import { render, staticRenderFns } from "./NarliFerryboatStatsByVehicleTypeTotalGraph.vue?vue&type=template&id=63ffd6b6&"
import script from "./NarliFerryboatStatsByVehicleTypeTotalGraph.vue?vue&type=script&lang=js&"
export * from "./NarliFerryboatStatsByVehicleTypeTotalGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports